import React, { useEffect } from "react";

/**
 * Renders a HubSpot embedded form using the hs-form-frame approach.
 *
 * Props:
 *  - portalId  {string}  HubSpot portal ID (e.g. "148454373")
 *  - formId    {string}  HubSpot form GUID (e.g. "32f4d07c-42f1-4784-82d2-2f8016ceeff6")
 *  - region    {string}  HubSpot region — "eu1" or "na1" (default: "eu1")
 */
export default function HubspotForm({ portalId, formId, region = "eu1" }) {
  useEffect(() => {
    const scriptId = `hs-forms-embed-${portalId}`;

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = `https://js-${region}.hsforms.net/forms/embed/${portalId}.js`;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, [portalId, region]);

  return (
    <div
      style={{
        width: "100%",
        margin: 0,
      }}
      className="hs-form-frame"
      data-region={region}
      data-form-id={formId}
      data-portal-id={portalId}
    />
  );
}
